import request from "../utils/request";
//获取列表
export function getPageList(params) {
  return request({
    url: `/page/list?pageNum=${params.currentPage}&pageSize=${params.currentPageSize}&name=${params.pageName}&type=${params.pageType}`,
    method: "get"
  });
}

//查询页面类型
export function queryType() {
  return request({
    url: `/page/queryType`,
    method: "get"
  });
}

//添加页面
export function pageCreate(params, list) {
  return request({
    url: `/page/add`,
    method: "post",
    data: {
      pageCO: {
        name: params.pageName,
        type: params.pageType,
        resourceComponentCOList: list,
        title:params.pageTitle
      }
    }
  });
}

//编辑页面
export function pageEdit(id, params, list) {
  return request({
    url: `/page/update`,
    method: "post",
    data: {
      pageCO: {
        id,
        name: params.pageName,
        type: params.pageType,
        resourceComponentCOList: list,
        title:params.pageTitle
      }
    }
  });
}

//查询
export function getInfoById(params) {
  return request({
    url: `/page/query?id=${params.id}`,
    method: "get"
  });
}

//删除页面
export function deletepage(params) {
  return request({
    url: `/page/delete`,
    method: "post",
    data: {
      id: params.id
    }
  });
}

// copyPage
export function copyPage(id) {
  return request({
    url: `/page/copy`,
    method: "post",
    data: {
      id,
    },
  });
}